import ResetPasswordUser from './ResetPasswordUserController';

export default ResetPasswordUser;
